
<modal :state="state" :index="index" @toggle-modal="emitHideModal" :size="'md'">
  <div slot="body" class="fds">
    <h3 class="modal-title h3">{{details.confirmationHeader}}</h3>
    <div class="spinner" v-if="addSpinner">
      <img src="@assets/images/_icon-spinner.svg" alt="Loading Spinner">
    </div>
    <p class="p" v-if="details.confirmationMessage">{{details.confirmationMessage}}</p>
    <p class="p" v-else-if="details.htmlSafeConfirmationMessage" v-html="details.htmlSafeConfirmationMessage"></p>
    <div class="row pt-2 modal-btn-group">
      <div class="col">
        <div class="cta">
          <button type="button" v-if="details.showCancel" @click="cancelEvent" :class="buttonClass('cancel')" data-action="cancel">{{details.cancelText}}</button>
          <button type="button" v-if="details.showAffirm" @click="affirmEvent" :class="buttonClass('affirm')" data-action="affirm">{{details.affirmText}}</button>
        </div>
      </div>
    </div>
  </div>
</modal>
